import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import Button from '../../components/ui/Button';
import { fetchEnterprise } from '../../api/enterprises';
import { EnterpriseManageProvider } from './EnterpriseManageContext';

const NAV = [
  { to: '', end: true, label: 'Résumé' },
  { to: 'equipe', end: false, label: 'Équipe' },
  { to: 'roles', end: false, label: 'Rôles' },
  { to: 'parametres', end: false, label: 'Paramètres' },
];

export default function EnterpriseManageLayout() {
  const { enterpriseId } = useParams();
  const base = `/enterprise-manage/${enterpriseId}`;
  const [enterprise, setEnterprise] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetchEnterprise(enterpriseId);
        if (!cancelled) setEnterprise(res?.data?.enterprise ?? null);
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Chargement impossible.');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [enterpriseId]);

  return (
    <>
      <Helmet>
        <title>{enterprise?.name || 'Entreprise'}</title>
      </Helmet>
      <Header />
      <main className="main-content">
        <Breadcrumb
          items={[
            { label: 'Entreprises', path: '/enterprise-manage' },
            { label: enterprise?.name || '…' },
          ]}
        />
        <div className="max-w-5xl mx-auto p-4 flex flex-col md:flex-row gap-6">
          <aside className="md:w-52 shrink-0 space-y-3">
            <Button asChild variant="ghost" size="sm" iconName="ArrowLeft" className="mb-1">
              <Link to="/enterprise-manage">Retour</Link>
            </Button>
            <p className="text-sm font-semibold text-foreground px-1">
              {enterprise?.name || '…'}
            </p>
            <nav className="flex md:flex-col gap-1">
              {NAV.map((item) => (
                <NavLink
                  key={item.to || 'summary'}
                  to={item.to ? `${base}/${item.to}` : base}
                  end={item.end}
                  className={({ isActive }) =>
                    `rounded-lg px-3 py-2 text-sm transition-colors ${
                      isActive
                        ? 'bg-primary/10 text-primary font-medium'
                        : 'text-muted-foreground hover:bg-muted/60 hover:text-foreground'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </aside>
          <div className="enterprise-manage-forms flex-1 min-w-0">
            {error ? (
              <p className="text-sm text-destructive" role="alert">
                {error}
              </p>
            ) : null}
            <EnterpriseManageProvider
              value={{ enterprise, setEnterprise, enterpriseId }}
            >
              <Outlet />
            </EnterpriseManageProvider>
          </div>
        </div>
      </main>
    </>
  );
}
